import { colors } from './colors'

function pxToRem(value: number, baseValue = 10) {
  return `${value / baseValue}rem`
}

const typography = {
  htmlFontSize: 10,
  fontFamily: '"SamsungSharpSans", "Roboto", "Montserrat", "Helvetica", "Arial", sans-serif',

  h1: {
    fontSize: pxToRem(40),
    lineHeight: 1.4,
    fontWeight: 600,
  },

  h2: {
    fontSize: pxToRem(28),
    lineHeight: 1.429,
    fontWeight: 600,
  },

  h3: {
    fontSize: pxToRem(24),
    lineHeight: 1.25,
    fontWeight: 600,
  },

  h4: {
    fontSize: pxToRem(20),
    lineHeight: 1.4,
    fontWeight: 600,
  },

  h5: {
    fontSize: pxToRem(18),
    lineHeight: 1.333,
    fontWeight: 600,
    letterSpacing: '0.02rem',
  },

  h6: {
    fontSize: pxToRem(16),
    lineHeight: 1.625,
    fontWeight: 500,
    letterSpacing: '0.02rem',
  },

  subtitle1: {
    fontSize: pxToRem(16),
    lineHeight: 1.625,
    fontWeight: 500,
  },

  subtitle2: {
    fontSize: pxToRem(12),
    lineHeight: 1.333,
    color: colors.text?.secondary,
  },

  body1: {
    fontSize: pxToRem(16),
    lineHeight: 1.625,
  },

  body2: {
    fontSize: pxToRem(14),
    lineHeight: 1.571,
  },

  button: {
    fontSize: pxToRem(16),
    lineHeight: 1.857,
    fontWeight: 600,
  },

  caption: {
    fontSize: pxToRem(12),
    lineHeight: 1.333,
  },

  overline: {
    fontSize: pxToRem(13),
  },
}

export { typography }
